import { isInChina } from "@/utils/commonUtils";
import { MAP_REGION_CN, MAP_REGION_MY } from "@/utils/config";

/** 当前站点是否国内（与 Home / HomePc 一致，基于域名） */
export const isChinaSite = () => isInChina();

/** 国内站 → 天地图；境外站 → MapTiler（与语言无关） */
export const shouldUseTiandituMap = () => isChinaSite();

/** MapTiler 底图标注语言：国内站固定中文；境外站按地图 Tab（中国 zh / 马来 en） */
export const getMapTilerStyleLanguage = (mapRegion) => {
  if (isChinaSite()) return "zh";
  return mapRegion === MAP_REGION_CN ? "zh" : "en";
};

/** 默认展示的国家 Tab：国内站 → 中国，境外站 → 马来西亚 */
export const getDefaultMapRegion = () =>
  isChinaSite() ? MAP_REGION_CN : MAP_REGION_MY;

/** 国内（isInChina）→ 高德；国外 → Apple / Google Maps */
export const shouldUseAmapForNavigation = () => isChinaSite();
